import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SidebarComponent } from './contents/shared/layout/sidebar/sidebar.component';
import { HeaderComponent } from './contents/shared/layout/header/header.component';
import { FooterComponent } from './contents/shared/layout/footer/footer.component';
import { LayoutComponent } from './contents/shared/layout/layout.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { CustomTranslateLoader } from './shared/loaders/custom-translate-loader';
import { environment } from 'src/environments/environment';
import { WebTypeConstant } from './shared/constants/common-constant';

@NgModule({
    declarations: [
        AppComponent,
        SidebarComponent,
        HeaderComponent,
        FooterComponent,
        LayoutComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        NgxSpinnerModule,
        FormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createCustomLoader,
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        // AuthService,
        // TokenService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function createCustomLoader(http: HttpClient): CustomTranslateLoader {
    const webType = localStorage.getItem(environment.TokenKeys.WebType) ?? WebTypeConstant.ADMIN; 
    let portal = '';

    if(webType == WebTypeConstant.ADMIN || webType == WebTypeConstant.ADMINSTAFF){
        portal = 'admin'
    } else if (webType == WebTypeConstant.MERCHANT || webType == WebTypeConstant.MERCHANTSTAFF){
        portal = 'merchant'
    } else if (webType == WebTypeConstant.AGENTUNLIMITED || webType == WebTypeConstant.AGENTSTAFFUNLIMITED){
        portal = 'agent'
    }

    return new CustomTranslateLoader(http, portal);
}